import React, { forwardRef, HTMLProps } from 'react';
import classNames from 'classnames';
import styles from './Popover.module.scss';

interface IPopoverProps extends HTMLProps<HTMLDivElement> {

} const Popover = forwardRef<HTMLDivElement, IPopoverProps>((
  { className, children, ...props },
  ref,
) => (
  <div ref={ref} className={classNames(styles.popover, className)} {...props}>
    {children}
  </div>

));

export default Popover;
